import React from 'react';
import { motion } from 'framer-motion';
import { stats } from '../mock';

const Stats = () => {
  return (
    <section className="relative bg-[#0f0d0b] text-white py-20 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{
        backgroundImage: 'linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)',
        backgroundSize: '60px 60px',
      }} />
      <div className="relative max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <div className="tag-label justify-center" style={{ color: '#f0c95a' }}>
            By The Numbers
          </div>
          <h2 className="font-serif-display text-3xl md:text-5xl font-black mt-4">A tradition of excellence</h2>
        </motion.div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-center">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.7 }}
              className="border-t border-[#c8942a]/40 pt-6"
            >
              <div className="font-serif-display text-5xl md:text-6xl font-black text-white">{s.value}</div>
              <div className="font-sans-pro text-[11px] uppercase tracking-[0.3em] text-white/60 mt-2">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
